import { createStore } from 'zustand/vanilla';
import { formatNumber } from './utils';

export interface ExchangeRate {
	[Code: string]: number;
}

export interface MoneyStore {
	exchangeRates: ExchangeRate;
	currentCurrencyCode: string;
	convertAmount: (value: number) => number;
	changeCurrency: (currency: string) => void;
	formatAmountWithCurrency: (value: number, lang: string) => string;
	getCurrencyCurrencySymbol: (lang: string) => string;
}

export function createMoneyStore(defaultCurrency: string, exchangeRates: ExchangeRate, currency: string) {
	return createStore<MoneyStore>()((set, get) => ({
		currentCurrencyCode: currency ?? defaultCurrency,
		exchangeRates,
		changeCurrency: (currency) => {
			document.cookie = `currency=${currency}; max-age=31536000; path=/`;
			set({ currentCurrencyCode: currency });
		},
		convertAmount: (amount: number) => {
			const state = get();
			const currentCurrencyCode = state.currentCurrencyCode;
			if (Object.keys(state.exchangeRates).length === 0) return amount;

			return currentCurrencyCode === defaultCurrency
				? amount
				: amount * (state.exchangeRates[Object.keys(state.exchangeRates).find((k) => k === currentCurrencyCode)!] ?? 1);
		},
		formatAmountWithCurrency: (value: number, lang: string) => {
			const state = get();

			return formatNumber(lang, state.convertAmount(value), {
				style: 'currency',
				minimumFractionDigits: 0,
				maximumFractionDigits: 0,
				currency: state.currentCurrencyCode,
				currencyDisplay: 'narrowSymbol',
			});
		},
		getCurrencyCurrencySymbol: (lang: string) => {
			return (0)
				.toLocaleString(lang, {
					style: 'currency',
					currencyDisplay: 'narrowSymbol',
					currency: get().currentCurrencyCode,
				})
				.replace(/\d/g, '')
				.trim();
		},
	}));
}
